<template>
  <div class="w-screen h-screen flex flex-col bg-white dark:bg-black">
    <slot />
  </div>
</template>
